import React from 'react';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined';
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import { Stack, Typography } from '@mui/material';

const Channel = ({ channel }) => {
	const isEmail = channel === 'email';
	const isSMS = channel === 'sms';

	const channelText = isEmail ? 'Email' : isSMS ? 'SMS' : (channel ?? '-');
	const Icon = isEmail
		? EmailOutlinedIcon
		: isSMS
			? PhoneAndroidOutlinedIcon
			: ContactPageOutlinedIcon;

	return (
		<Stack direction='row' sx={{ alignItems: 'center' }}>
			<Icon fontSize='24px' sx={{ minWidth: '24px' }} />
			<Typography variant='inherit'>{channelText}</Typography>
		</Stack>
	);
};
export default Channel;
